import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { TrainingDto } from '../../../api/types/dtos/training';
import CreateTrainingModal from '../modals/CreateTrainingModal';

interface TrainingSelectorProps {
  trainings: TrainingDto[];
  selectedTraining: TrainingDto | null;
  onSelect: (training: TrainingDto | null) => void;
  loading?: boolean;
}

const TrainingSelector: React.FC<TrainingSelectorProps> = ({
  trainings,
  selectedTraining,
  onSelect,
  loading = false,
}) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const handleCreateSuccess = (trainingId: string) => {
    // Find the newly created training and select it
    const newTraining = trainings.find((t) => t.id === trainingId);
    if (newTraining) {
      onSelect(newTraining);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', mb: 3 }}>
      <Box sx={{ flex: 1 }}>
        <Autocomplete
          value={selectedTraining}
          onChange={(_, newValue) => onSelect(newValue)}
          options={trainings}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option) => (
            <li {...props}>
              <Box>
                <Typography variant="body1">{option.name}</Typography>
                {option.description && (
                  <Typography variant="caption" color="text.secondary">
                    {option.description}
                  </Typography>
                )}
              </Box>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Seleccionar Capacitación"
              placeholder="Buscar capacitación..."
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          loading={loading}
          fullWidth
        />
      </Box>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => setCreateModalOpen(true)}
        sx={{ minWidth: 'auto', px: 3, py: 1.8 }}
      >
        Nueva
      </Button>
      <CreateTrainingModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />
    </Box>
  );
};

export default TrainingSelector;



